// extracted by mini-css-extract-plugin
export default {"heading":"AddCreative_heading__t4aNX","wrapper":"AddCreative_wrapper__ZDPx5"};